import {
  RESET_DATA,
  LOAD_DATA,
  UPDATE_BUNDLED_PRICING,
  UPDATE_TABLE_DATA,
} from '../config/types';

export default function actionTrigger(type, data = {}) {
  return { type, data };
}

export function actionLoadData(data) {
  return actionTrigger(LOAD_DATA, data);
}

export function actionResetData() {
  return actionTrigger(RESET_DATA);
}

export function actionUpdateBundledPricing(data) {
  return actionTrigger(UPDATE_BUNDLED_PRICING, data);
}

export function actionUpdateTableData(data) {
  return actionTrigger(UPDATE_TABLE_DATA, data);
}



// WEBPACK FOOTER //
// ./app/actions/index.js